import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveHelpWidgetComponent } from './live-help-widget/live-help-widget.component';

@NgModule({
  declarations: [LiveHelpWidgetComponent],
  imports: [CommonModule],
  exports: [LiveHelpWidgetComponent]
})
export class LiveHelpModule {}
